import { Component } from '@angular/core';
import { AlertService, DatasourceService, AuthService } from '@app/core/services';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { CreateEditWindowComponent } from './create-edit-window.component';
import { IntlService } from '@progress/kendo-angular-intl';
import { State } from '@progress/kendo-data-query';
import { VehicleInventoryValidator } from '@app/core/validators';
import { User } from '@app/core/models';
import { ZonedDate } from "@progress/kendo-date-math";
import { environment } from '@environments/environment';


@Component({
  selector: 'create-edit-vehicle-entry',
  template: `
  <div class="k-overlay" *ngIf="opened"></div>
  <kendo-window [width]="860" title="{{ (mode == 'CREATE') ? 'Nuevo' : 'Editar' }} {{ label }} {{ (mode == 'CREATE') ? '' : '(Id: ' + form.value.id + ')' }}" *ngIf="opened" (close)="onClose()" [(state)]="windowState">
  
    <!-- {{ form.value | json }} Es valido: {{ form.valid }} -->
    
    <form novalidate [formGroup]="form">
      <div class="example-wrapper form-detail">          
          <div class="row">
              <div class="col-xs-6 col-sm-6 example-col">
                  <kendo-label text="Autoridad:"></kendo-label>
                  <dynamic-dropdownlist formControlName="id_authority" [table]="'authorities'" [valueField]="'id'" [textField]="'name'" [showAll]="true"></dynamic-dropdownlist>
              </div>
              <div class="col-xs-6 col-sm-6 example-col">
                  <kendo-label text="Depósito:"></kendo-label>
                  <dynamic-dropdownlist formControlName="id_deposit" [table]="'deposits'" [valueField]="'id'" [textField]="'name'" [showAll]="true"></dynamic-dropdownlist>                  
              </div>              
              <div class="col-xs-6 col-sm-6 example-col">
                  <kendo-label text="Tipo de Vehículo:"></kendo-label>
                  <dynamic-dropdownlist formControlName="id_vehicle_type" [table]="'vehicles_types'" [valueField]="'id'" [textField]="'name'" [showAll]="true"></dynamic-dropdownlist>
              </div>
              <div class="col-xs-6 col-sm-6 example-col">
                  <kendo-label text="Fecha de Entrada:"></kendo-label>
                  <kendo-textbox-container>
                    <kendo-datepicker formControlName="entry_date" [format]="'dd-MMM-yyyy'"></kendo-datepicker>
                  </kendo-textbox-container>
                  <div *ngIf="f.entry_date.invalid && (f.entry_date.dirty || f.entry_date.touched)">                  
                    <div *ngIf="f.entry_date.errors">
                      <kendo-formerror *ngIf="f.entry_date.errors.required">
                        Error: Campo requerido.
                      </kendo-formerror>
                    </div>   
                  </div>
              </div>
              <div class="col-xs-6 col-sm-6 example-col">
                  <kendo-label text="Folio de expediente:"></kendo-label>
                  <kendo-textbox-container>                                        
                    <kendo-textbox formControlName="sku_exp" [clearButton]="true" controlTrim></kendo-textbox>
                  </kendo-textbox-container> 
                  <div *ngIf="f.sku_exp.invalid && (f.sku_exp.dirty || f.sku_exp.touched)">                  
                    <div *ngIf="f.sku_exp.errors">
                      <kendo-formerror *ngIf="f.sku_exp.errors.required">
                        Error: Campo requerido.
                      </kendo-formerror>
                      <kendo-formerror *ngIf="f.sku_exp.errors.ExistsVehicleInventory">
                        Error: Ya existe una entrada con este folio.
                      </kendo-formerror>
                    </div>   
                  </div>              
              </div>
              <div class="col-xs-6 col-sm-6 example-col">
                  <kendo-label text="Folio de inventario:" [optional]="true"></kendo-label>
                  <kendo-textbox-container>                                        
                    <kendo-textbox formControlName="sku_inv" [clearButton]="true" controlTrim></kendo-textbox>
                  </kendo-textbox-container> 
                  <div *ngIf="f.sku_inv.invalid && (f.sku_inv.dirty || f.sku_inv.touched)">                  
                    <div *ngIf="f.sku_inv.errors">
                      <kendo-formerror *ngIf="f.sku_inv.errors.required">
                        Error: Campo requerido.
                      </kendo-formerror>
                      <kendo-formerror *ngIf="f.sku_inv.errors.ExistsVehicleInventory">
                        Error: Ya existe una entrada con este folio.
                      </kendo-formerror>
                    </div>   
                  </div>              
              </div>
              <div class="col-xs-6 col-sm-6 example-col">
                  <kendo-label text="Marca:"></kendo-label>
                  <kendo-textbox-container>                    
                    <dynamic-autocomplete formControlName="marck" [table]="'vehicles_inventories'" [valueField]="'marck'" [showAll]="true" controlTrim></dynamic-autocomplete>
                  </kendo-textbox-container> 
                  <div *ngIf="f.marck.invalid && (f.marck.dirty || f.marck.touched)">                  
                    <div *ngIf="f.marck.errors">
                      <kendo-formerror *ngIf="f.marck.errors.required">
                        Error: Campo requerido.
                      </kendo-formerror>
                    </div>   
                  </div>              
              </div>
              <div class="col-xs-6 col-sm-6 example-col">
                  <kendo-label text="Color:"></kendo-label>
                  <kendo-textbox-container>
                    <dynamic-autocomplete formControlName="color" [table]="'vehicles_inventories'" [valueField]="'color'" [showAll]="true" controlTrim></dynamic-autocomplete>
                  </kendo-textbox-container> 
                  <div *ngIf="f.color.invalid && (f.color.dirty || f.color.touched)">                  
                    <div *ngIf="f.color.errors">
                      <kendo-formerror *ngIf="f.color.errors.required">
                        Error: Campo requerido.
                      </kendo-formerror>
                    </div>   
                  </div>              
              </div>
              <div class="col-xs-6 col-sm-6 example-col">
                  <kendo-label text="Placas:"></kendo-label>
                  <kendo-textbox-container>
                    <kendo-textbox formControlName="plaque" [clearButton]="true" controlTrim [upperCase]="true"></kendo-textbox>
                  </kendo-textbox-container> 
                  <div *ngIf="f.plaque.invalid && (f.plaque.dirty || f.plaque.touched)">                  
                    <div *ngIf="f.plaque.errors">
                      <kendo-formerror *ngIf="f.plaque.errors.required">
                        Error: Campo requerido.
                      </kendo-formerror>
                    </div>   
                  </div>              
              </div>
              <div class="col-xs-6 col-sm-6 example-col">
                  <kendo-label text="Número de serie:" [optional]="true"></kendo-label>
                  <kendo-textbox-container>
                    <kendo-textbox formControlName="serie" [clearButton]="true" controlTrim [upperCase]="true"></kendo-textbox>
                  </kendo-textbox-container> 
                  <div *ngIf="f.serie.invalid && (f.serie.dirty || f.serie.touched)">                  
                    <div *ngIf="f.serie.errors">
                      <kendo-formerror *ngIf="f.serie.errors.required">
                        Error: Campo requerido.
                      </kendo-formerror>
                    </div>   
                  </div>              
              </div>
              <div class="col-xs-12 col-sm-12 example-col">
                  <kendo-label text="Lugar:"></kendo-label>
                  <kendo-textbox-container>
                    <kendo-textbox formControlName="place" [clearButton]="true" controlTrim [upperCase]="true"></kendo-textbox>
                  </kendo-textbox-container> 
                  <div *ngIf="f.place.invalid && (f.place.dirty || f.place.touched)">                  
                    <div *ngIf="f.place.errors">
                      <kendo-formerror *ngIf="f.place.errors.required">
                        Error: Campo requerido.
                      </kendo-formerror>
                    </div>   
                  </div>              
              </div>
              <div class="col-xs-12 col-sm-12 example-col">
                  <kendo-label text="Observaciones:" [optional]="true"></kendo-label>
                  <kendo-textbox-container>
                    <textarea kendoTextArea formControlName="observations" rows="3" controlTrim></textarea>
                  </kendo-textbox-container>
              </div>
              <div class="col-xs-12 col-sm-12 example-col">
                  <kendo-label text="Fotografías:" [optional]="true"></kendo-label>
                  <multiple-imagen-upload formControlName="photos" [folder]="'vehicles'"></multiple-imagen-upload>               
              </div>            
          </div>
      </div>
    </form>

    <div class="text-right">
        <button type="button" class="k-button" (click)="onCancel()">Cancelar</button>
        <button type="button" class="k-button k-primary ml-1" (click)="onSave()" [disabled]='!form.valid'>Guardar</button>
    </div>
       
  </kendo-window>      
  `,
  styles: [`
    .k-textbox-container, input.k-textbox {
      width: 100%;
    }    
  `],
  providers: [ DatasourceService ]
})    
export class CreateEditVehicleEntryComponent extends CreateEditWindowComponent {

  //Métodos

  constructor(protected authService: AuthService, protected service : DatasourceService, protected alertService : AlertService, protected intl: IntlService) {

    super(authService, service, alertService);

  }
  
  //@Override
  public getObjectString(dataItem: any): string {

    return [
      `Id: '${dataItem.id}'`,      
      `Folio de expediente: '${dataItem.sku_exp}'`,
      `Marca: '${dataItem.marck}'`,
      `Color: '${dataItem.color}'`,
      `Placas: '${dataItem.plaque}'`
    ].join('\n')

  };

  //@Override
  protected getFormGroup(user: User, dataItem?: any): FormGroup {

    if(this.mode == 'CREATE'){
      this.getNextSku();
    }
    else if(this.mode == 'EDIT'){
      
      let state : State = {
        skip: 0, 
        take: 0, 
        // sort: [{field: 'sku_exp', dir: 'desc'}], 
        filter: {
          logic: "and",
          filters: [
              {
                  field: 'id_vehicle_inventory',
                  operator: 'eq',
                  value: dataItem.id
              }
          ]
        }, 
        group: []
      }

      this.service.get('vehicles_inventories_photos', state)
        .subscribe(
          (res) => {
            console.log("RESPONSE------: ", res);
            this.form.patchValue({
              photos: res.data.map(function (gallery, index, array) {
                return {uid: gallery.id, src: gallery.photo, deleted: 0}; 
              })
            });
          },
          (fail) => {        
            console.log("Error", fail);
          }
        ); 

      // this.service.getAll('vehicles_inventories_photos', null, (table, res)=>{

      //   console.log(table, res)

      // });
    }

    const tzDate = ZonedDate.fromUTCDate((dataItem) ? new Date(dataItem.entry_date) : new Date(), environment.timezone);

    return new FormGroup({
      'id': new FormControl((dataItem) ? dataItem.id: 0),        
      'entry_date': new FormControl((dataItem) ? new Date(tzDate.toUTCString().replace('Dev', 'Dec')): new Date(), Validators.required), 
      'sku_exp': new FormControl((dataItem) ? dataItem.sku_exp: 0, Validators.required, VehicleInventoryValidator.createValidator((dataItem) ? dataItem.id: 0, this.service)),
      'sku_inv': new FormControl((dataItem) ? dataItem.sku_inv: ""),
      'marck': new FormControl((dataItem) ? dataItem.marck: "", Validators.required),
      'color': new FormControl((dataItem) ? dataItem.color: "", Validators.required),
      'plaque': new FormControl((dataItem) ? dataItem.plaque: "", Validators.required),
      'serie': new FormControl((dataItem) ? dataItem.serie: ""),
      'place': new FormControl((dataItem) ? dataItem.place: "", Validators.required),
      'id_authority': new FormControl((dataItem) ? dataItem.id_authority: 0, Validators.required),
      'id_deposit': new FormControl((dataItem) ? dataItem.id_deposit: 1, Validators.required),
      'id_vehicle_type': new FormControl((dataItem) ? dataItem.id_vehicle_type: 2, Validators.required),
      'id_vehicle_status': new FormControl((dataItem) ? dataItem.id_vehicle_status: 1),
      'observations': new FormControl((dataItem) ? dataItem.observations: ""),
      'photos': new FormControl((dataItem) ? dataItem.photos: [])
    });

  };

  //@Override
  protected getData(formGroup: FormGroup): Object {
    
    return Object.assign({}, formGroup.value, { 
      entry_date: this.intl.formatDate(formGroup.value.entry_date, "yyyy-MM-dd"),
      // output_date: null
    });

  };

  //@Override
  public onSave(): void {
    
    let data = this.getData(this.form);
    console.log('data', data)

    if(this.mode == 'CREATE'){
      this.service.addRow(this.table, data) 
        .subscribe(
          (res) => {
            console.log("POST Request is successful: ", this.table, data);
            console.log("mode = " + this.mode);

            let id: number = res.data[0].id;

            // GUARDAR FOTOS.
            this.form.value.photos.forEach((row) => { 
              row['id_vehicle_inventory'] = id;
              row['photo'] = row.src;
            });

            let photos = this.form.value.photos.filter(x => x.deleted == 0)

            console.log(photos);

            this.service.add_batch('vehicles_inventories_photos', photos, null, (table, res)=>{

              console.log(table, res)

            });

            this.save.emit({mode: this.mode, dataItem: res.data[0]});
            this.opened = false;
          },
          (fail) => {        
            console.log("Error", fail);
            // this.alertService.showError(fail.error.detail.sql + ' ' + fail.error.detail.sqlMessage);
          }
        ); 
    }
    else {
      this.service.updateRow(this.table, data) 
        .subscribe(
          (res) => {
            console.log("POST Request is successful: ", this.table, data);
            console.log("mode = " + this.mode);

            let id: number = res.data[0].id;

            // GUARDAR FOTOS.
            this.form.value.photos.forEach((row) => { 
              row['id_vehicle_inventory'] = id;
              row['photo'] = row.src;
            });

            console.log(this.form.value.photos);


            this.service.remove_batch('vehicles_inventories_photos', 'id_vehicle_inventory', id, null, (table, res)=>{

              //1.- ELIMINAR LOS REGISTROS CON deleted == 1
              let photos = this.form.value.photos.filter(x => x.deleted == 0);
              console.log(photos);
        
              this.service.add_batch('vehicles_inventories_photos', photos, null, (table, res)=>{
        
                // console.log(table, res)
        
              });
        
            });

            this.save.emit({mode: this.mode, dataItem: res.data[0]});
            this.opened = false;
          },
          (fail) => {        
            console.log("Error", fail);
            // this.alertService.showError(fail.error.detail.sql + ' ' + fail.error.detail.sqlMessage);
          }
        ); 
    }

  }

  protected getNextSku() {

    let state : State = {
      skip: 0, 
      take: 1, 
      sort: [{field: 'sku_exp', dir: 'desc'}], 
      // filter: {
      //   logic: "and",
      //   filters: [
      //       {
      //           field: 'id_ejercicio',
      //           operator: 'eq',
      //           value: id_ejercicio
      //       }
      //   ]
      // }, 
      group: []
    }

    this.service.get('vehicles_inventories', state)
      .subscribe(
        (res) => {
          // console.log("RESPONSE: ", res);
          this.form.patchValue({
            sku_exp: parseInt(res.data[0].sku_exp) + 1,
          });
        },
        (fail) => {        
          console.log("Error", fail);
        }
      ); 

  }

}
